import dashboardsDashboardUi from 'images/dashboards_screenshot-crop_dashboard-ui.webp';
import chartsChartUi from 'images/queries-nrql_screenshot-crop_dashboard-chart-color.webp';
import * as React from 'react';
export default {
  dashboardsDashboardUi,
  chartsChartUi,
  React
};